import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3f98c684")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_item = _resolveComponent("item")
  const _component_group = _resolveComponent("group")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_group, { label: "Order Summary" }, {
      default: _withId(() => [
        _createVNode(_component_item, {
          label: "Billing Code:",
          value: 
                    `Transaction may appear with the description ${_ctx.shippingBillId} on your credit card or bank statement.`
                
        }, null, 8, ["value"]),
        _createVNode(_component_item, {
          label: "Books ordered",
          value: _ctx.orderDetails.books
        }, null, 8, ["value"]),
        _createVNode(_component_item, {
          label: "Price",
          value: _ctx.price
        }, null, 8, ["value"])
      ]),
      _: 1
    })
  ]))
})